import { Typography } from "@mui/material";
import React from "react";

export const ToolErrorPage = () => {
  return (
    <>
      <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
        <Typography variant="h3">Tool does not exists or buggy</Typography>
        <br/>
        <Typography variant="p2">
          Unfortenatally this tool is not yet added to the platform or has some
          problems :(
        </Typography>
        <br/>
        <Typography>
          We intend to add an option for contribution to this framework, we will
          update when it will be available.
        </Typography>
        <br/>
        <Typography>
          For requests and feedback currently you can use twitter @OlegLerner
        </Typography>
      </div>
    </>
  );
};
